import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Breadcrumb from '../components/Breadcrumb'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Spinner from '../components/Spinner'
import classNames from 'classnames'
import { initialize } from '../store/pagedata'
import { signIn } from '../store/auth'
import styles from '../styles/signin.module.scss'
import useDarkMode from 'use-dark-mode'

const SignIn = () => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const error = useSelector((state) => state.auth.error)
  const isLoading = useSelector((state) => state.auth.isLoading)
  const success = useSelector((state) => state.auth.success)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  useEffect(() => {
    dispatch(initialize())
  }, [])

  const onSubmit = (e) => {
    e.preventDefault()
    dispatch(signIn({ email, password }))
  }

  return (
    <>
      <Helmet>
        <meta name='description' content='EDHREC Sign In' />
        <meta name='keywords' content='EDHREC,sign,in' />
        <title>Sign In | EDHREC</title>
      </Helmet>
      <Breadcrumb breadcrumb={[{ '/signin': 'Sign In' }]} />
      <h1 className='page-heading'>Sign In</h1>
      <div
        className={classNames(styles.container, {
          [styles.dark]: darkMode.value,
        })}
      >
        <div className={styles.containerInner}>
          <h2 className={styles.header}>Sign In</h2>
          <form onSubmit={onSubmit}>
            <Form.Group>
              <Form.Control
                onChange={(e) => setEmail(e.target.value)}
                placeholder='Email'
                type='text'
                value={email}
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                placeholder='Password'
                type='password'
                value={password}
              />
            </Form.Group>
            <Form.Group>
              <Button
                className='btn-block'
                disabled={isLoading}
                type='submit'
                variant='primary'
              >
                {isLoading ? <Spinner /> : 'Sign In'}
              </Button>
            </Form.Group>
            <Form.Group>
              {error && <Alert variant='danger'>{error}</Alert>}
              {success && <Alert variant='success'>{success}</Alert>}
            </Form.Group>
            <Form.Group className='align-items-center d-flex flex-column'>
              <Link to={{ pathname: '/signup', state: { noTop: true } }}>
                Sign Up
              </Link>
            </Form.Group>
            <Form.Group className='align-items-center d-flex flex-column'>
              <Link
                to={{ pathname: '/forgot-password', state: { noTop: true } }}
              >
                Forgot your password?
              </Link>
            </Form.Group>
          </form>
        </div>
      </div>
    </>
  )
}

export default SignIn
